export default __webpack_public_path__ + "static/media/img7.c087c73d.png";